import { sendRequest, sendRequestWithPayload } from "@/common/http";

interface TokenResult {
  token: string;
}

export interface ExportConversationResult {
  pdf_file_bytes: string;
}

function fetchCsrfToken(): Promise<string> {
  return new Promise((resolve, reject) => {
    sendRequest(
      { uri: "/export/token", camelize: true },
      (result: TokenResult) => resolve(result.token),
      reject,
    );
  });
}

export async function exportConversationToPdf(
  html: string,
  header: string,
  subHeader: string,
): Promise<ExportConversationResult> {
  const token = await fetchCsrfToken();

  const formData = new FormData();
  formData.append("html", html);
  formData.append("header", header);
  formData.append("sub_header", subHeader);
  formData.append("export_id", "ai-chat-export");
  formData.append("_csrf_token", token);

  return new Promise((resolve, reject) => {
    sendRequestWithPayload(
      { uri: "/export", body: formData },
      (result: ExportConversationResult) => resolve(result),
      reject,
    );
  });
}
